<template>
  <div class="head-section">
        <div class="el-col el-col-12">
          <h2 style="font-weight: 700; font-size: 30px; line-height: 45px">
            {{ $t("homework.create_new_assignment") }}
          </h2>
          <label class="page page-active">{{ $t('homework.head_section.input information') }} </label>
          <label :class="step > 1 ?'page page-active':'page'">{{ $t('homework.head_section.select_lessons') }} </label>
          <label :class="step > 2 ? 'page page-active':'page'">{{ $t('homework.head_section.review_assignment') }}</label>
        </div>
        <div class="el-col el-col-12" v-if="step > 1">
          <div class="number-chip">
            <span class="number">{{ lessonSelected.length }}</span>
            <i class="elsa-icon-cart"></i>
          </div>
        </div>
    </div>
</template>
<script>
export default {
  components: {
  },
  props: {
      lessonSelected: {},
      step: {
        type: Number,
        default: 0
      },

  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
@import "../../../scss/_colors.scss";
    .create-assignment-page{
        .number-chip {
            justify-self: flex-end;
            &,
            &:active,
            &:focus,
            &:hover {
                padding: 8px 16px;
            }
            .number {
                font-size: 12px;
                border-radius: 100%;
                background-color: $purple;
                color: $white;
                width: 18px;
                height: 18px;
                display: inline-flex;
                justify-content: center;
                align-items: center;
                transition: background 0.2s, font-weight 0.2s;
                float: right;
                margin-left: -20px;
            }
        }
        .head-section {
            padding: 0px 0px 20px;
            display: flex;
            i.elsa-icon-cart {
              float: right;
            }
            i.elsa-icon-cart:before {
              height: 50px;
              width: 40px;
              padding-right: 0px;
              margin-right: -1px;
              margin-top: -6px;
            }
            .page {
              font-weight: normal;
              font-size: 12px;
              line-height: 16px;
              letter-spacing: 0.005em;
              color: #d1d1d6;
            }
            .page-active {
              font-weight: 600;
              color: #007eff;
            }
        }
    }
</style>
